import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Heading,
  Stack,
  StackDivider,
  Box,
  Text,
  Image,
  Divider,
  ButtonGroup,
  Button,
  Wrap,
  Center,
  Flex,
  Spacer,
  IconButton,
  useBreakpointValue,
  HStack,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { transformData, findCategoryById } from '../util.js';
import { Rating } from './Rating.js';
import { UserBanner } from './User.js';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import ReactMarkdown from 'react-markdown';
import MD from './MD';
import React from 'react';
import {} from '@chakra-ui/react';

import { cans } from '../icblast.js';

export function OrderPage() {
  let { id } = useParams();

  let [order, setOrder] = useState(false);
  useEffect(() => {
    (async () => {
      let r = await cans.qgig.get_order(parseInt(id, 10));
      console.log(r);
      setOrder(r);
    })();
  }, []);

  return (
    <Center>
      <Stack w="800px">Order</Stack>
    </Center>
  );
}
